<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">智能锁管理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="设备名">
          <el-input v-model="formInline.device_name" clearable :placeholder="`请输入`"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.device_status" clearable placeholder="请选择">
            <el-option label="在线" value="online"></el-option>
            <el-option label="离线" value="offline"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="name" fixed label="设备名">
        </custom-table-column>
        <custom-table-column prop="devSerialNum" label="序列号">
        </custom-table-column>
        <custom-table-column prop="statusText" label="设备状态">
        </custom-table-column>
        <custom-table-column prop="deviceModel" label="设备型号">
        </custom-table-column>
        <custom-table-column prop="deviceType" label="设备类型">
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="240">
          <template slot-scope="scope">
            <template v-if="scope.row.deviceStatus == 'online'">
              <el-button type="text" @click="handleOpen(scope.row.indexCode, 'open', '开门')" size="small">开门</el-button>
              <el-button type="text" @click="handleOpen(scope.row.indexCode, 'keepOpen', '常开门')"
                size="small">常开</el-button>
              <el-button type="text" @click="getTemPwd(scope.row)" size="small">生成临时密码</el-button>
            </template>
            <el-button type="text" v-if="scope.row.deviceStatus == 'offline'"
              @click="getOfflineCode(scope.row.indexCode)" size="small">离线开门口令</el-button>
            <el-button type="text" @click="handleChildren(scope.row)" size="small">开门记录</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="开门记录" :visible.sync="detailDialogVisible" width="986px">
      <div>
        <el-form :inline="true" :model="formInline1" class="demo-form-inline" label-position="left">
          <el-form-item label="开始时间">
            <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择"
              v-model="formInline1.start_time"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择"
              v-model="formInline1.end_time"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery1">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <custom-table :data="tableData1" border style="width: 100%">
          <custom-table-column fixed label="序号" type="index" width="50">
          </custom-table-column>
          <custom-table-column prop="eventName" label="操作时间">
            <template slot-scope="scope">
              <span>{{ scope.row.eventTime ? $until.getTimeStr(new Date(scope.row.eventTime).getTime() / 1000, "-") : ''
              }}</span>
            </template>
          </custom-table-column>
          <!-- <custom-table-column prop="personName"  label="姓名">
          </custom-table-column>
          <custom-table-column prop="jobNo" label="工号">
          </custom-table-column> -->
          <custom-table-column prop="eventName" label="事件名称">
          </custom-table-column>
        </custom-table>
        <div class="pageLine">
          <PageLine :total='total1' ref="pageChild1" @getList="getList1"></PageLine>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="临时密码" :visible.sync="passDialogVisible" width="586px">
      <div v-if="ruleForm.code" class="lock-box">
        <span class='lock-code' v-for="(code, i) in ruleForm.code.split('')" :key="i">{{ code }}</span>
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="ruleForm.phone" clearable placeholder="请输入" style="width:360px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleForm', sendMessage)">发送短信</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinValidate],
  data() {
    return {
      formInline: {
        device_name: '',
        device_status: ''
      },
      formInline1: {
        device_index_code: '',
        start_tiime: '',
        end_time: '',
      },
      levell: [1, 2, 3],
      detailDialogVisible: false,
      passDialogVisible: false,
      tableData1: [],
      total1: 0,
      loading: false,
      ruleForm: {
        code: '',
        phone: '',
        use_end_time: '',
        device_name: ''
      },
      rules: {
        phone: [{ required: true, message: `请输入`, trigger: 'blur' },
        { validator: this.checkphone, trigger: 'blur' }],
      },
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    async getOfflineCode(device_index_code) {
      let params = { device_index_code };
      let res = await this.$api.instance.interfaceServer('api/smart_lock/smart-lock/offline-password', 'post', params);
      if (res.code == 0 && res.data) {
        if (res.data.offlineCode) {
          this.codeWin(res.data.offlineCode, '离线开门口令')
        } else {
          this.$message({
            type: 'warning',
            message: `未找到口令!`,
          });
        }
      }
    },
    async sendMessage() {
      let res = await this.$api.instance.interfaceServer('api/sms/sendcode', 'post', this.ruleForm);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          message: `发送成功!`,
        });
      }
      this.passDialogVisible = false
    },
    async getTemPwd(row) {
      this.ruleForm.device_name = row.name
      let params = { device_index_code: row.indexCode };
      let res = await this.$api.instance.interfaceServer('api/smart_lock/smart-lock/generate-temp-password', 'post', params);
      if (res.code == 0 && res.data) {
        if (res.data.password) {
          // this.codeWin(res.data.password, '临时密码')
          this.ruleForm.code = res.data.password
          this.ruleForm.use_end_time = res.data.expire_time
          this.passDialogVisible = true
        } else {
          this.$message({
            type: 'warning',
            message: `未找到临时密码!`,
          });
        }
      }
    },
    codeWin(code, title) {
      const html = this.$createElement
      let spans = []
      for (let i = 0; i < code.length; i++) {
        spans.push(<span class='lock-code'>{code[i]}</span>)
      }
      this.$msgbox({
        title,
        message: html('div', { class: 'lock-box' }, spans),
        closeOnClickModal: false,
        showCancelButton: false,
        showConfirmButton: false,
      }).then(action => {
      });
    },
    handleOpen(indexCode, operation_type, str) {
      this.$confirm(`此操作将${str}, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.openLock(indexCode, operation_type);
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除',
          // });
        });
    },
    async openLock(device_index_code, operation_type) {
      let params = { device_index_code, operation_type };
      let res = await this.$api.instance.interfaceServer('api/smart_lock/smart-lock/open-door', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          message: `操作成功!`,
        });
      }
    },
    handleChildren(row) {
      this.formInline1.device_index_code = row.indexCode
      this.tableData1 = []
      this.detailDialogVisible = true;
      this.handleQuery1()
    },
    handleQuery1() {
      this.$nextTick(() => {
        this.$refs.pageChild1.page = 1;
        this.getList1();
      });
    },
    async getList1() {
      // this.tableData1 = [
      //   {
      //     "certNum": "3262293373",
      //     "deviceIndexCode": "feng_0409_门_1",
      //     "eventId": "68a557e2-1e9d-4628-b753-863144824312",
      //     "eventName": "acs.acs.eventType.failCardNotInMultipleAuthGroup",
      //     "eventTime": "2020-04-15T20:01:35+08:00",
      //     "eventType": 197634,
      //     "jobNo": "3262293373",
      //     "name": "feng_0409",
      //     "orgIndexCode": "4db7c89d-0ce6-4826-9146-6b71f037d81e",
      //     "orgPathName": "9ab08c9e-8e78-48a0-8e9e-013c2068fc9c",
      //     "personId": "de4f4b1694244a58bfa6f9ee88996fcd",
      //     "personName": "fengzi"
      //   }
      // ]
      // this.total1 = 20
      // return
      let params = this.$until.deleteNullPrototype(this.formInline1);
      params.page = this.$refs.pageChild1.page;
      params.size = this.$refs.pageChild1.size;
      let res = await this.$api.instance.interfaceServer('api/smart_lock/smart-lock/open-records', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData1 = res.data.data;
        this.total1 = res.data.total;
      }
    },
    async getList() {
      // this.tableData = [{ "indexCode": "7b397039fbf840f7ab408199e0cddc24", "name": "精勤楼网关130", "deviceType": "gateway", "deviceModel": "CS-LT-GW5-R4L", "deviceStatus": "offline", "parentIndexCode": null, "regionName": "精勤楼（实验楼）", "regionPath": "@root000000@1450e10914cd4d11a9197e079b1daeb0@", "devSerialNum": "BF8622636", "capability": "", "description": "", "location": null, "orgIndexCode": null, "orgPathName": null, "installTime": null, "lastOnlineTime": null, "createdAt": "2025-08-26 16:54:29", "updatedAt": "2025-08-26 16:54:29", "statusText": "离线" }, { "indexCode": "4789a739ec3642d48d67aeada2155c05", "name": "精勤楼111", "deviceType": "gatewayLock", "deviceModel": "CS-LT70-V100-RBCP", "deviceStatus": "online", "parentIndexCode": "7b397039fbf840f7ab408199e0cddc24", "regionName": "精勤楼（实验楼）", "regionPath": "@root000000@1450e10914cd4d11a9197e079b1daeb0@", "devSerialNum": "BF8623683", "capability": "@isSupportFingerPwd@support_person@support_offlinepassword@support_finger@support_doorHolidayPlan@support_doorsensor@support_card@support_temporaryPassword@support_doorstatus@support_add_psw@", "description": "BF8622636", "location": null, "orgIndexCode": null, "orgPathName": null, "installTime": null, "lastOnlineTime": null, "createdAt": "2025-08-26 16:54:29", "updatedAt": "2025-08-26 16:54:29", "statusText": "在线" }, { "indexCode": "42f9b23090dc41998683f828727fe8ab", "name": "精勤楼113", "deviceType": "gatewayLock", "deviceModel": "CS-LT70-V100-RBCP", "deviceStatus": "online", "parentIndexCode": "7b397039fbf840f7ab408199e0cddc24", "regionName": "精勤楼（实验楼）", "regionPath": "@root000000@1450e10914cd4d11a9197e079b1daeb0@", "devSerialNum": "BF8623657", "capability": "@isSupportFingerPwd@support_person@support_offlinepassword@support_finger@support_doorHolidayPlan@support_doorsensor@support_card@support_temporaryPassword@support_doorstatus@support_add_psw@", "description": "BF8622636", "location": null, "orgIndexCode": null, "orgPathName": null, "installTime": null, "lastOnlineTime": null, "createdAt": "2025-08-26 16:54:29", "updatedAt": "2025-08-26 16:54:29", "statusText": "在线" }, { "indexCode": "acea67fe02cb46b18d157bd6649ee8c8", "name": "精勤楼网关132", "deviceType": "gateway", "deviceModel": "CS-LT-GW5-R4L", "deviceStatus": "online", "parentIndexCode": null, "regionName": "精勤楼（实验楼）", "regionPath": "@root000000@1450e10914cd4d11a9197e079b1daeb0@", "devSerialNum": "BF8622615", "capability": "", "description": "", "location": null, "orgIndexCode": null, "orgPathName": null, "installTime": null, "lastOnlineTime": null, "createdAt": "2025-08-26 16:54:29", "updatedAt": "2025-08-26 16:54:29", "statusText": "在线" }, { "indexCode": "b6043b2d0a8243a79278978f71ec6c16", "name": "精勤楼网关136", "deviceType": "gateway", "deviceModel": "CS-LT-GW5-R4L", "deviceStatus": "online", "parentIndexCode": null, "regionName": "成都铁路卫生学校", "regionPath": "@root000000@", "devSerialNum": "BF8622609", "capability": "", "description": "", "location": null, "orgIndexCode": null, "orgPathName": null, "installTime": null, "lastOnlineTime": null, "createdAt": "2025-08-26 16:54:29", "updatedAt": "2025-08-26 16:54:29", "statusText": "在线" }, { "indexCode": "d8004bc8c44e43a7bd8e5d0aa1e0dbd9", "name": "精勤楼网关135", "deviceType": "gateway", "deviceModel": "CS-LT-GW5-R4L", "deviceStatus": "online", "parentIndexCode": null, "regionName": "成都铁路卫生学校", "regionPath": "@root000000@", "devSerialNum": "BF8622580", "capability": "", "description": "", "location": null, "orgIndexCode": null, "orgPathName": null, "installTime": null, "lastOnlineTime": null, "createdAt": "2025-08-26 16:54:29", "updatedAt": "2025-08-26 16:54:29", "statusText": "在线" }]
      // this.total = 20
      // return
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/smart_lock/smart-lock/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      this.$refs.pageChild.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="less">
.pageHeader:before {
  width: var(--width);
}

.lock-box {
  text-align: center;
  padding: 24px 0 32px;

  span {
    padding: 6px;
    margin: 4px 8px;
    font-size: 22px;
    border-radius: 4px;
    // text-decoration: underline;
    border: 1px solid #cfcfcf;
  }
}

.el-cascader-node {
  height: auto !important;
  line-height: 2;
}

.el-cascader__dropdown {
  max-width: 100% !important;
  overflow: auto;
}

.el-cascader-node__label {
  line-height: 1.2;
}

.cascader-tip {
  color: rgb(132, 146, 166);
  font-size: 13px;
  max-width: 400px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 12px;
}
</style>
